"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedState = void 0;
const generic_browser_lib_1 = require("@squiz/generic-browser-lib");
/**
 * Loads the selected state for the provided resource
 */
const useSelectedState = ({ plugin, resource }) => {
    // Find the resolver for this resource
    const renderSelectedResource = resource && plugin?.renderSelectedResource;
    return (0, generic_browser_lib_1.useAsync)({
        callback: () => (resource && renderSelectedResource ? renderSelectedResource(resource) : null),
        defaultValue: null,
    }, [resource]);
};
exports.useSelectedState = useSelectedState;
